module.exports = "::ng-deep .mat-ink-bar {\r\n    background-color: #ffca28 !important; /* Color of the underline */\r\n}\r\n::ng-deep .mat-tab-label.mat-tab-label-active {\r\n    background: none;\r\n}\r\n::ng-deep .mat-tab-label:focus {\r\n    background:none;\r\n}\r\n.pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/lz30/lz30.component.css
// module id = 987
// module chunks = 1